require('./lib/closest')
const {bind} = require('./lib/bind')
const throttle = require('./lib/throttle')

let touch = false

bind(document, 'touchstart', function() {
  touch = true
})

bind(document, 'DOMContentLoaded', function() {
  Array.from(document.querySelectorAll('.deck-preview-image')).forEach((element) => {
    const deck = element.closest('.deck-preview')
    const preview = element.querySelector('.deck-preview-scrub-slide')
    const background = element.querySelector('.deck-preview-scrub-background')
    const scrubber = element.querySelector('.deck-preview-scrubber')
    const url = deck.dataset.coverImage
    const slideCount = deck.dataset.slideCount

    bind(element, 'mousemove', function(e) {
      if (touch) return
      const slide = Math.max(Math.ceil(e.offsetX / element.offsetWidth * slideCount) - 1, 0)
      const slideUrl = url.replace(/[0-9]+\.jpg/, slide + '.jpg')
      preview.style.display = 'block'
      background.style.display = 'block'
      scrubber.style.display = 'block'
      preview.style.backgroundImage = 'url("' + slideUrl + '")'
      background.style.backgroundImage = 'url("' + slideUrl + '")'
      scrubber.style.width = 100 * (slide / (slideCount - 1)) + '%'
    })

    bind(element, 'mouseleave', function(e) {
      if (touch) return
      preview.style.display = 'none'
      background.style.display = 'none'
      scrubber.style.display = 'none'
    })
  })

  bind(document, 'sd:embed:image', function(e) {
    const cssUrl = e.detail.cssUrl
    const pageUrl = `${location.protocol}//${location.host}${location.pathname}?slide=${e.detail.index + 1}`.replace(/\?slide=1$/, '')

    if ('replaceState' in window.history) { window.history.replaceState({}, false, pageUrl); }

    const talk = document.querySelector('.deck-background')
    if (talk) {
      talk.style.backgroundImage = cssUrl
    }

    document.querySelector('meta[property=og\\:image]').setAttribute('content', e.detail.imgUrl)
    document.querySelector('meta[name=twitter\\:image\\:src]').setAttribute('content', e.detail.imgUrl)
  })

  if(document.getElementById('edit-slides-toggle')){
    bind(document.getElementById('edit-slides-toggle'), 'click', function(e) {
      document.querySelectorAll('.edit-slide').forEach(function(item){
        item.toggleAttribute('hidden')
      })
    })
  }

  // Set Publish Date to Now when "Anyone now" is selected in the format "Month Day, Year"
  if(document.getElementById('talk_view_policy_public')){
    bind(document.getElementById('talk_view_policy_public'), 'change', function(e) {
      if(e.target.checked && document.getElementById('talk_formatted_published_at').value == ''){
        document.getElementById('talk_formatted_published_at').value = new Date().toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
      }
    })
  }

  document.querySelectorAll('.deck-sort').forEach(function(item){
    bind(item, 'change', function(e) {
      document.getElementById('form-deck-sort').submit()
    })
  })

  // Show/Hide URL inputs whitelisted emdedding
  if(document.getElementById('talk_embed_visibility')){
    toggleAllowListRequired()

    // On Change
    bind(document.getElementById('talk_embed_visibility'), 'change', function(e) {
      if(e.target.value == 'allowlist'){
        document.getElementById('talk_embed_allowlist').removeAttribute('hidden')
        document.getElementById('col-js-add-input').removeAttribute('hidden')
      } else {
        document.getElementById('talk_embed_allowlist').setAttribute('hidden', true)
        document.getElementById('col-js-add-input').setAttribute('hidden', true)
      }
      toggleAllowListRequired()
    })

    // On Load
    if(document.getElementById('talk_embed_visibility').value == 'allowlist'){
      document.getElementById('talk_embed_allowlist').removeAttribute('hidden')
      document.getElementById('col-js-add-input').removeAttribute('hidden')
    }

    // Add new URL input
    if(document.getElementById('js-add-input')){
      bind(document.getElementById('js-add-input'), 'click', function(e) {
        e.preventDefault()
        const html = document.getElementById('talk_embed_allowlist').querySelector('.row-allowlist').outerHTML
        let clone = document.createElement('div')
        clone.innerHTML = html
        clone.querySelector('input').value = ''
        document.getElementById('talk_embed_allowlist').appendChild(clone.firstChild)
      })
    }

    // Remove parent row when removing a URL
    if(document.getElementById('talk_embed_allowlist')){
      bind(document.getElementById('talk_embed_allowlist'), 'click', function(e) {
        if(e.target.classList.contains('js-remove-input')){
          e.preventDefault()
          if(document.querySelectorAll('.row-allowlist').length > 1){
            e.target.closest('.row-allowlist').remove()
          }
        }
      })
    }

  }

})

function toggleAllowListRequired(state){
  const allowList = document.getElementById('talk_embed_visibility')
  const status = (allowList.value == 'allowlist') ? true : false
  const inputs = document.querySelectorAll('.allowlist-url')
  inputs.forEach(function(input){
    if(status == true){
      input.setAttribute('required', true)
    } else {
      input.removeAttribute('required')
    }
  })
}
